export const CANOPY_DATE_FIELD = 'created_at';

export type CanopyStatsFeature = {
  properties: {
    event_name: string;
    created_at: string;
    ef_rank: number;
    kml_id: string;
    canopy_published_date: string;
    structures_exposed: number;
    county_intersect: string;
    state_intersect: string;
    fips_intersect: string;
    residential_struc_exposed: number;
    initial_date: string;
  };
};
